import { INTERNAL_MESSAGE_ERROR_KEY } from '../constants';
import { InternalMessageType } from '../enums';
import { InternalMessageEvent } from '../types';
import { isInternalMessagePayload } from './payload';
import { isInternalMessageSource } from './source';

export const isInternalMessageType = (
  value: unknown
): value is InternalMessageType =>
  Object.values(InternalMessageType).includes(value as InternalMessageType);

export const isInternaldMessageEvent = (
  messageEvent: MessageEvent
): messageEvent is InternalMessageEvent => {
  const { source, type, payload } = messageEvent.data;
  if (!isInternalMessageSource(source)) return false;

  if (!isInternalMessageType(type)) {
    throw new Error(
      `${INTERNAL_MESSAGE_ERROR_KEY} Receive invalid internal message type: ${type}`
    );
  }

  if (!isInternalMessagePayload(type, payload)) {
    throw new Error(
      `${INTERNAL_MESSAGE_ERROR_KEY} Receive invalid payload for internal message type: ${type}`
    );
  }

  return true;
};
